import { Button, Label, useStyles, useTheme } from '@archipro-design/aria';
import { AnimatePresence, motion } from 'framer-motion';
import { useProductTagging } from '../../context';
import * as S from './ProductTaggingFixedBar.style';
import { useSearchParams } from '@remix-run/react';

const ProductTaggingFixedBar = () => {
    const {
        state: { isTagging },
        dispatch,
    } = useProductTagging();
    const { css } = useStyles();
    const theme = useTheme();
    const [searchParams, setSearchParams] = useSearchParams();

    return (
        <AnimatePresence>
            {isTagging ? (
                <motion.div
                    initial={{ y: '100%' }}
                    animate={{ y: 0 }}
                    exit={{ y: '100%' }}
                    transition={{ duration: 0.3 }}
                    className={css(S.FixedBarContainer)}
                >
                    <Label
                        variant="01"
                        variables={{
                            color: theme.siteVariables.colors.charcoal['250'],
                        }}
                        className={css(S.LabelStyling)}
                    >
                        Click the photo to start tagging
                    </Label>
                    <Button
                        variables={{
                            buttonPadding: 24,
                            primaryButtonTextColorNormal:
                                theme.siteVariables.colors.white['000'],
                            primaryButtonTextColorHover:
                                theme.siteVariables.colors.white['100A'],
                            primaryButtonBackgroundColorNormal:
                                theme.siteVariables.colors.charcoal[250],
                            primaryButtonBackgroundColorHover:
                                theme.siteVariables.colors.charcoal[260],
                        }}
                        size={24}
                        className={css(S.ButtonDoneTagging)}
                        onClick={() => {
                            searchParams.delete('tagging');
                            setSearchParams(searchParams, {
                                replace: false,
                                preventScrollReset: true,
                            });
                            dispatch({ type: 'TOGGLE_TAGGING' });
                            dispatch({ type: 'RESET_TAGGING_FLAGS' });
                        }}
                    >
                        DONE TAGGING
                    </Button>
                </motion.div>
            ) : null}
        </AnimatePresence>
    );
};

export default ProductTaggingFixedBar;
